import React, { useEffect, useState } from "react";
import {
  ToggleLeft as Toggle,
  MapPin,
  Hash,
  Barcode,
  Building2,
  Users,
  Edit,
} from "lucide-react";
import { IPayment, IReservation } from "../../common/types";
import { TAX_EUR } from "../../../utils/constants";

function format_date(date: Date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return [
    year,
    (month > 9 ? "" : "0") + month,
    (day > 9 ? "" : "0") + day,
  ].join("-");
}

interface IPropertyStats {
  totalCheckIns: number;
  totalNights: number;
  totalGuests: number;
  totalIEAT: number;
  // totalCanceled?: number;
  // totalTransmitted?: number;
}

function preparePropertyInfo(
  reservation: Partial<IReservation>
): IPropertyStats {
  const res: IPropertyStats = {
    totalCheckIns: 0,
    totalNights: 0,
    totalGuests: 0,
    totalIEAT: 0,
    // totalCanceled: 0,
    // totalTransmitted: 0,
  };

  reservation.reservation_applications?.forEach((reservation_application) => {
    let nights: number = 0;
    if (
      reservation_application.checkin_date &&
      reservation_application.checkout_date
    ) {
      const checkin_date_d = new Date(reservation_application.checkin_date);
      const checkout_date_d = new Date(reservation_application.checkout_date);
      nights = Math.floor(
        (checkout_date_d.getTime() - checkin_date_d.getTime()) /
          (1000 * 60 * 60 * 24)
      );
    }

    const checkin = Boolean(reservation_application.finalized_at);
    const canceled = Boolean(reservation_application.canceled_at);
    const transmitted = Boolean(reservation_application.transmitted_at);
    const ieat = reservation_application.tax_amount * TAX_EUR;

    res.totalCheckIns += checkin ? 1 : 0;
    res.totalNights += nights;
    res.totalGuests += reservation_application.guests?.length ?? 0;
    res.totalIEAT += ieat;
    // res.totalCanceled += canceled ? 1 : 0;
    // res.totalTransmitted += transmitted ? 1 : 0;
  });

  return res;
}

// interface PropertyCardProps {
//   reservation: IReservation;
//   onToggleActive: (id: number) => void;
// }

interface IPropertyCardEditProps {
  accomodation: any;
  // setAccomodation: (x: any) => void;
  // onSave: () => void;
  // onDelete: () => void;
  saved: boolean;
  // onBadSave?: (() => void) | null;
  onToggleActive: () => void;
  onEdit: () => void;
  onUpgrade: () => void;
  onChangeSubscription: (payment: IPayment, cancel: boolean) => void;
  payments: IPayment[];
}

export function PropertyCardView2({
  accomodation,
  saved,
  onToggleActive,
  onEdit,
  onUpgrade,
  onChangeSubscription,
  payments,
}: IPropertyCardEditProps) {
  const [stats, setStats] = useState<IPropertyStats | null>(null);
  useEffect(() => {
    const stats_ = preparePropertyInfo(accomodation);
    setStats(stats_);
  }, [accomodation]);
  const canToggleActive =
    accomodation.id !== null && accomodation.id !== undefined;
  return (
    <div
      className={
        "rounded-lg border bg-card text-card-foreground shadow-sm" +
        `relative border-l-4 ${
          !accomodation.active ? "border-l-red-400" : "border-l-green-400"
        } p-4 hover:shadow-sm transition-shadow duration-200 bg-white`
      }
    >
      {/* Status indicator strip */}
      {/* <div
        className={`absolute left-0 top-0 h-full w-1.5 ${
          accomodation.active ? "bg-green-500" : "bg-red-500"
        }`}
      /> */}

      <div className="p-6 pl-8">
        {/* Header */}
        <div className="flex items-start justify-between">
          <div>
            <div className="flex items-center gap-2">
              <Building2 className="h-5 w-5 text-[#E76D6D]" />
              <h3 className="text-xl font-bold text-gray-900">
                {accomodation.name}
              </h3>
            </div>
            <div className="mt-1 flex items-center gap-2">
              <span
                className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
                  saved
                    ? "bg-green-100 text-green-800"
                    : "bg-red-100 text-red-800"
                }`}
              >
                {saved ? "● Saved" : "● Not saved"}
              </span>
            </div>
          </div>
          {canToggleActive && (
            <button
              onClick={() => onToggleActive()}
              className={`flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
                accomodation.active
                  ? "bg-green-50 text-green-700 hover:bg-green-100"
                  : "bg-red-50 text-red-700 hover:bg-red-100"
              }`}
            >
              <Toggle className="h-4 w-4" />
              {accomodation.active ? "Active" : "Inactive"}
            </button>
          )}
        </div>

        {/* accomodation Details */}
        <div className="mt-6 grid grid-cols-3 gap-4">
          <div className="flex items-center gap-2">
            <Hash className="h-4 w-4 text-gray-400" />
            <div>
              <p className="text-sm font-medium text-gray-500">HUT Number</p>
              <p className="font-mono text-gray-900">
                {accomodation.roat_number}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Barcode className="h-4 w-4 text-gray-400" />
            <div>
              <p className="text-sm font-medium text-gray-500">Internal Code</p>
              <p className="font-mono text-gray-900">
                {accomodation.room_code}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Users className="h-4 w-4 text-gray-400" />
            <div>
              <p className="text-sm font-medium text-gray-500">Max Travelers</p>
              <p className="text-gray-900">{6}</p>
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-between">
          {/* Address */}
          <div>
            <div className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-gray-400" />
              <p className="text-sm font-medium text-gray-500">Address</p>
            </div>
            <div className="mt-1 space-y-1 pl-6">
              <p className="text-gray-900">{accomodation.address}</p>
              <p className="text-gray-900">{accomodation.postal_code_city}</p>
            </div>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-4 gap-2">
          <div className="bg-blue-50 p-2 rounded-lg text-center">
            <div className="text-lg font-semibold text-blue-600 mb-0.5">
              {stats?.totalCheckIns ?? 0}
            </div>
            <div className="text-[10px] text-blue-600/80">Check-ins</div>
          </div>
          <div className="bg-purple-50 p-2 rounded-lg text-center">
            <div className="text-lg font-semibold text-purple-600 mb-0.5">
              {stats?.totalNights ?? 0}
            </div>
            <div className="text-[10px] text-purple-600/80">Nights</div>
          </div>
          <div className="bg-amber-50 p-2 rounded-lg text-center">
            <div className="text-lg font-semibold text-amber-600 mb-0.5">
              {stats?.totalGuests ?? 0}
            </div>
            <div className="text-[10px] text-amber-600/80">Guests</div>
          </div>
          <div className="bg-emerald-50 p-2 rounded-lg text-center">
            <div className="text-lg font-semibold text-emerald-600 mb-0.5">
              {stats?.totalIEAT ?? 0}€
            </div>
            <div className="text-[10px] text-emerald-600/80">IEAT</div>
          </div>
        </div>

        {payments.map((payment) => {
          const packageType = payment.name;
          let isSubscriptionCancelled = false;
          if (payment.params) {
            try {
              const paramsObj = JSON.parse(payment.params);
              isSubscriptionCancelled = paramsObj.cancel_at_period_end;
            } catch (e) {
              console.warn("Failed to parse payment params", payment);
            }
            
          }
          // const onReactivateSubscription = () => {};
          const paid_at_date = new Date(payment.paid_at);

          const subscriptionPaid = paid_at_date
            ? format_date(paid_at_date)
            : "-";
          let subscriptionRenewal = '';
          if (paid_at_date) {
            const next_date = new Date(new Date(paid_at_date).setMonth(paid_at_date.getMonth() + 1));
            subscriptionRenewal = format_date(next_date);
          };
          return (
            <div className="mt-6 grid grid-cols-3 gap-2 border-t pt-2 border-gray-100">
              <div className="flex items-center gap-1">
                <div>
                  <div className="text-xs text-gray-500 mb-0.5">Package</div>
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 font-medium text-xs text-foreground">
                    {packageType}
                  </div>
                </div>
                <button
                  className={
                    `ml-1 h-6 text-xs ${
                      packageType === "Premium"
                        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                        : "border-purple-200/70 text-purple-500 hover:bg-purple-50/50 hover:text-purple-600 hover:border-purple-300/70"
                    }` +
                    " inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground"
                  }
                  disabled={packageType === "Premium"}
                  onClick={() => onUpgrade()}
                >
                  Upgrade
                </button>
              </div>
              <div>
                <div className="text-xs text-gray-500 mb-0.5">Paid</div>
                <div className="text-xs font-medium text-gray-700">
                  {subscriptionPaid}
                </div>
              </div>
              <div>
                <div className="text-xs text-gray-500 mb-0.5">Renewal</div>
                <div className="flex items-center gap-1">
                  {isSubscriptionCancelled ? (
                    <>
                      <div className="text-xs font-medium text-red-500">
                        CANCELLED
                      </div>
                      <div
                        onClick={() => onChangeSubscription(payment, false)}
                        className="h-6 text-xs bg-green-50 border-green-200/70 text-green-600 hover:bg-green-100/50 hover:text-green-700 hover:border-green-300/70 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground"
                      >
                        Reactivate
                      </div>
                    </>
                  ) : (
                    <div style={{display: 'flex', gap: '0.5rem'}}>
                    <div className="text-xs font-medium text-gray-700">
                      {subscriptionRenewal}
                    </div>
                    <div
                        onClick={() => onChangeSubscription(payment, true)}
                        className="h-7 text-xs border-red-200/70 text-red-500 hover:bg-red-50/50 hover:text-red-600 hover:border-red-300/70 transition-colors inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground"
                        style={{cursor: "pointer"}}
                      >
                        Cancel
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}

        <div className="mt-6 flex justify-end">
          <button
            onClick={() => onEdit()}
            className={`flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-colors bg-orange-50 text-orange-700 hover:bg-orange-100`}
          >
            <Edit className="h-4 w-4" />
            Edit
          </button>
        </div>
      </div>
    </div>
  );
}
